export enum BLOCK_ACCOUNT_REASONS {
  ACCOUNT_CLOSED = 'account_closed',
  ACCOUNT_BLOCKED = 'account_blocked',
  ACCOUNT_TEMPORARY_SUSPENDED = 'account_temporary_suspended',
  ACCOUNT_BLOCKED_FAILED_VERIFICATION = 'account_blocked_failed_verification',
}

export function isBlockAccountReason(
  value: string | null | undefined,
) {
  return Object.values(BLOCK_ACCOUNT_REASONS).includes(value as BLOCK_ACCOUNT_REASONS);
}
